<script>
/* global L */
import { LCircle, LMarker } from 'vue2-leaflet'

import markerIcon from "images/map/map-marker.png"

export default {
  props: {
    latLng: {
      type: [Array, Object],
      required: true
    }
  },

  data () {
    return {
      marker: new L.Icon({
        iconUrl: markerIcon,
        iconAnchor: [22, 22]
      })
    }
  },

  methods: {
    mapObject () { return this.$refs.marker.mapObject },
    addLayer (layer) { this.$parent.addLayer(layer) },
    removeLayer (layer) { this.$parent.removeLayer(layer) }
  },

  render (createElement) {
    if (this.isCircleMarker) {
      return createElement(
        LCircle,
        {
          ref: 'marker',
          props: {
            latLng: this.latLng,
            stroke: false,
            fillColor: "#E37641",
            radius: 200
          },
          on: this.$listeners
        },
        [
          this.$slots.default
        ]
      )
    }

    return createElement(
      LMarker,
      {
        ref: 'marker',
        props: {
          latLng: this.latLng,
          icon: this.marker
        },
        on: this.$listeners
      },
      [
        this.$slots.default
      ]
    )
  }
}
</script>
